"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = IndicatorSeparator;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
/* eslint react/prop-types: 0 */

function IndicatorSeparator(_ref) {
  var innerProps = _ref.innerProps,
    selectProps = _ref.selectProps;
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    className: selectProps.classes.indicatorSeparator,
    "data-metrics": selectProps.dataMetrics.indicatorSeparator
  }, innerProps));
}